/* lkp2-4.js - Lush Keepsake personaliser v2, part 4 of 16 (readable source: build/src/lkp2.js; split by build/minify.py) */
(function(){'use strict';var K=window.__lkp2k=window.__lkp2k||{};
var D=K.D,DASH=K.DASH,EN=K.EN,SEP_RE=K.SEP_RE,POUND_FMT=K.POUND_FMT,EMAIL=K.EMAIL,BLANK_DEFAULT=K.BLANK_DEFAULT,NUM_WORDS=K.NUM_WORDS,SWATCH=K.SWATCH,INK_DARK=K.INK_DARK,INK_LIGHT=K.INK_LIGHT,CAP=K.CAP,esc=K.esc,h=K.h,clamp=K.clamp,clone=K.clone,lc=K.lc,isObj=K.isObj,merge=K.merge,firstInt=K.firstInt,money=K.money,hash=K.hash,debounce=K.debounce,cleanLabel=K.cleanLabel,fontByN=K.fontByN,swatchFor=K.swatchFor,inkFor=K.inkFor,CFG=K.CFG,loadConfig=K.loadConfig,IMG=K.IMG,loadImg=K.loadImg,ART_INK=K.ART_INK,ARTTXT=K.ARTTXT,artBaseUrl=K.artBaseUrl,artText=K.artText,artRaster=K.artRaster,MOTIF=K.MOTIF,motifImg=K.motifImg,MAPS=K.MAPS,mapNorm=K.mapNorm,mapDist=K.mapDist,mapJson=K.mapJson,mapFind=K.mapFind,mapPlace=K.mapPlace,ICONIMG=K.ICONIMG,iconSvg=K.iconSvg,iconImg=K.iconImg,FONTREADY=K.FONTREADY,fontReady=K.fontReady,QR=K.QR,loadQR=K.loadQR,cleanRegion=K.cleanRegion,LEGACY=K.LEGACY,fallbackConfig=K.fallbackConfig,lineFields=K.lineFields,P=K.P,MORSE=K.MORSE,pathPts=K.pathPts,polyLen=K.polyLen,visRun=K.visRun,drawPathText=K.drawPathText,toMorse=K.toMorse,subMax=K.subMax,subKey=K.subKey,propKey=K.propKey,faceKey=K.faceKey,textKey=K.textKey,optText=K.optText,propVal=K.propVal,fmtDate=K.fmtDate,fmtTime=K.fmtTime,drawPlaceholder=K.drawPlaceholder,drawClock=K.drawClock,drawCalendar=K.drawCalendar,drawSpotify=K.drawSpotify,drawQR=K.drawQR,NOISE=K.NOISE,noisePattern=K.noisePattern,autoTone=K.autoTone,shade=K.shade,drawPlate=K.drawPlate,residual=K.residual,METAL=K.METAL;
P.prototype.start = function (all) {
var p = this.product, c = null;
var key = p.handle, mf = p.cfg && isObj(p.cfg) ? (p.cfg.lkp2 || p.cfg) : null;
this.cfgSource = 'fallback';
if (mf && mf.off === true) { this.root.hidden = true; this.cfgSource = 'off'; return; } // sold as is: no personaliser
if (mf && mf.finishOnly === true) { c = clone(mf); c.faces = []; c.engraveToggle = false; c.note = false; this.override = null; this.cfgSource = 'metafield'; }
else if (mf && (mf.faces || mf['extends'])) {
c = clone(mf); this.override = null; this.cfgSource = 'metafield';
} else if (all && all.products && all.products[key]) {
c = clone(all.products[key]); this.cfgSource = 'asset';
}
if (c && c['extends'] && all && all.templates && all.templates[c['extends']]) c = merge(all.templates[c['extends']], c);
if (this.override && this.override.lkp2) { c = merge(c || { faces: [] }, this.override.lkp2); this.cfgSource = 'override'; }
if (!c || ((!c.faces || !c.faces.length) && !c.finishOnly)) { c = fallbackConfig(this.override, p); this.cfgSource = 'fallback'; }
if (c.engraved === false) c.engraveToggle = false;
(c.faces || []).forEach(function (f) { if (f.art) { c.art = true; if (f.art.mm) f.mm = f.art.mm; } });
this.cfg = c;
this.artBase = artBaseUrl(this.root);
if (c.art) this.root.classList.add('is-art');
this.finishOnly = c.finishOnly === true;
this.choices = c.engraved === false || this.finishOnly;
if (this.finishOnly) this.root.classList.add('is-finish');
this.optIndex = {};
var me = this;
(p.options || []).forEach(function (o, i) { me.optIndex[lc(o)] = i; });
var colOpt = this.optName('colour');
this.colourIsVariant = colOpt != null && this.optIndex[lc(colOpt)] != null;
if (!this.colourIsVariant) this.st.colour = c.colours && c.colours.length === 1 ? c.colours[0] : (c.colourDefault || null);
try { document.documentElement.classList.add('lkp2-on'); } catch (e) {}
this.host = this.root;
if (!this.finishOnly) {
var md = h('div', { class: 'lkp2 lkp2--modal' + (c.art ? ' is-art' : ''), 'data-lkp2-modal': true });
document.body.appendChild(md); this.root = md;
}
this.build();
this.readVariant();
this.sync(true);
this.bind();
this.host.classList.add('is-ready');
this.host.hidden = false;
this.checkCart();
if (location.hash === '#personalise') setTimeout(function () { me.open(); }, 400);
};
P.prototype.open = function () {
if (this.host === this.root) return;
var me = this;
this._ret = document.activeElement;
this.root.classList.add('is-open');
document.documentElement.classList.add('lkp2-lock');
if (!this.st.step || this.steps().indexOf(this.st.step) < 0) this.st.step = this.steps()[0];
this.goStep(this.st.step);
setTimeout(function () { me.drawStage(); var x = me.root.querySelector('.lkp2__x'); if (x) try { x.focus({ preventScroll: true }); } catch (e) {} }, 40);
};
P.prototype.close = function () {
if (this.host === this.root || !this.root.classList.contains('is-open')) return;
this.root.classList.remove('is-open');
document.documentElement.classList.remove('lkp2-lock');
this.renderPageSum();
var b = this._ret && this._ret.isConnected ? this._ret : this.host.querySelector('.lkp2__go:not([hidden])');
if (b && b.focus) try { b.focus({ preventScroll: true }); } catch (e) {}
};
P.prototype.isModal = function () { return !!this.host && this.host !== this.root; };
P.prototype.hasFinish = function () {
if (!this.secFinish) return false;
return (!this.colourIsVariant && (this.cfg.colours || []).length > 1) || !this.elPick.hidden || !!this.elGFont;
};
P.prototype.steps = function () {
var s = []; if (this.hasFinish()) s.push('finish');
this.faces().forEach(function (f) { s.push(f.id); });
s.push('review');
return s;
};
P.prototype.unitWord = function () {
var u = this.cfg.unit || '', me = this, ci = this.countInfo(), cids = ci ? ci.counted.map(function (f) { return f.id; }) : [], labs = this.faces().filter(function (f) { return me.drawable(f) || cids.indexOf(f.id) >= 0; }).map(function (f) { return String(f.label || ''); });
if (u && !/engrav|area|piece|side/.test(u)) { var w = this.units(1); return w.charAt(0).toUpperCase() + w.slice(1); }
var st = labs.map(function (l) { var q = /^(.+?) \d+$/.exec(l); return q ? q[1] : null; });
if (labs.length > 1 && st[0] && st.every(function (x) { return x === st[0]; })) return st[0];
if (/side/i.test((this.cfg.count || {}).option || '') || labs.every(function (l) { return /side|front|back|top|bottom|inside|outside|lid|edge|end/i.test(l); })) return 'Side';
return 'Item';
};
P.prototype.goStep = function (id) {
if (!this.isModal()) return;
var st = this.steps(); if (st.indexOf(id) < 0) id = st[0];
this.st.step = id;
if (id !== 'finish' && id !== 'review') this.setActive(id); else this.renderSteps();
var b = this.root.querySelector('.lkp2__mbody'); if (b) b.scrollTop = 0;
};
P.prototype.stepBy = function (d) {
var st = this.steps(), i = st.indexOf(this.st.step);
this.goStep(st[Math.max(0, Math.min(st.length - 1, (i < 0 ? 0 : i) + d))]);
};
P.prototype.renderSteps = function () {
if (!this.isModal() || !this.elSteps) return;
var me = this, st = this.steps(), faces = this.faces(), cur = this.st.step;
if (st.indexOf(cur) < 0) cur = this.st.step = st[0];
var isFace = cur !== 'finish' && cur !== 'review', i = st.indexOf(cur), word = this.unitWord();
var ci = this.countInfo(), cids = ci ? ci.counted.map(function (f) { return f.id; }) : [];
var drawn = faces.filter(function (f) { return me.drawable(f) || cids.indexOf(f.id) >= 0; });
var html = '';
st.forEach(function (id) {
var f = id === 'finish' || id === 'review' ? null : me.face(id);
var lab = f ? f.label : (id === 'finish' ? 'Finish' : 'Review');
var num = f ? String(faces.indexOf(f) + 1) : (id === 'finish' ? '0' : String(faces.length + 1));
var done = f ? me.hasContent(f) : (id === 'finish' ? !!me.colour() : false);
var bad = f && me.errs && me.errs[f.id];
html += '<button type="button" class="lkp2__step' + (id === cur ? ' is-on' : '') + (done ? ' is-done' : '') + (bad ? ' has-error' : '') + '" data-step="' + esc(id) + '"' + (id === cur ? ' aria-current="step"' : '') + '>' +
(num ? '<i>' + num + '</i>' : '<i class="lkp2__stepok"></i>') + '<span>' + esc(lab) + '</span></button>';
});
this.elSteps.innerHTML = html;
this.elSteps.hidden = !faces.length;
var on = this.elSteps.querySelector('.is-on'); if (on && on.scrollIntoView) try { on.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (e) {}
this.secFinish.hidden = cur !== 'finish';
this.elPanels.hidden = !isFace;
this.secReview.hidden = cur !== 'review';
this.elPanels.querySelectorAll('.lkp2__panel').forEach(function (p) {
var id = p.getAttribute('data-face'), f = me.face(id), k = drawn.indexOf(f), el = p.querySelector('[data-sidx]');
p.classList.toggle('is-open', isFace && id === cur);
if (el) el.innerHTML = f && k >= 0 ? (drawn.length > 1 ? word + ' ' + (k + 1) + ' of ' + drawn.length : (me.choices ? 'Your choice' : me.verb().made === 'engraving' ? 'Your engraving' : 'Your wording')) : 'Also choose';
});
var prev = this.root.querySelector('[data-act="prev"]'), next = this.root.querySelector('[data-act="next"]');
var ok = this.root.querySelector('[data-act="ok"]'), cw = this.root.querySelector('.lkp2__confwrap');
if (prev) prev.hidden = i <= 0;
if (next) {
var nx = st[i + 1], nf = nx && nx !== 'review' ? this.face(nx) : null;
next.hidden = cur === 'review';
next.innerHTML = nx === 'review' ? 'Review &amp; confirm &rarr;' : (cur === 'finish' ? 'Start: ' + esc(nf ? nf.label : '') + ' &rarr;' : 'Next: ' + esc(nf ? nf.label : '') + ' &rarr;');
}
if (ok) ok.hidden = cur !== 'review';
if (cw) cw.hidden = cur !== 'review' || !faces.length;
this.root.setAttribute('data-step', isFace ? 'face' : cur);
};
P.prototype.confirmOk = function () {
this.writeProps();
if (this.validate(true)) this.close();
};
P.prototype.removeAll = function () {
var me = this;
this.allFaces().forEach(function (f) { delete me.st.vals[f.id]; me.st.same[f.id] = false; delete me.st.files[f.id]; });
this.st.touched = {}; this.st.confirm = false; this.st.showErrors = false;
var cb = this.root.querySelector('[data-confirm]'); if (cb) cb.checked = false;
this._sig = null; this.sync();
};
P.prototype.renderPageSum = function () {
if (this.host === this.root) return;
var el = this.host.querySelector('[data-pagesum]'), go = this.host.querySelector('.lkp2__go'); if (!el || !go) return;
var me = this, vb = this.verb(), faces = this.faces(), blank = !this.choices && this.isBlank(), parts = [], html = '';
faces.forEach(function (f) { if (me.hasContent(f)) parts.push('<span>' + esc(f.label) + ' ' + esc(me.describe(f) || 'as shown') + '</span>'); });
var key = esc(vb.prop || 'Your choices');
if (blank) html = 'Plain option chosen: nothing will be added.';
else if (!this.choices && !this.st.engrave) html = '<b>' + key + ':</b> none, sent plain. <span class="lkp2__pact"><button type="button" data-act="open">Edit</button></span>';
else if (parts.length) html = '<b>' + key + ':</b> ' + parts.join(', ') + (this.st.confirm ? '' : ' <em>(not confirmed yet)</em>') + ' <span class="lkp2__pact"><button type="button" data-act="open">Edit</button> | <button type="button" data-act="premove">Remove</button></span>';
el.innerHTML = html; el.hidden = !html;
go.hidden = blank || (!this.choices && !this.st.engrave) || (parts.length > 0 && this.st.confirm);
};
P.prototype.optName = function (role) {
var o = this.cfg.options || {};
if (o[role]) return o[role];
if (role === 'count' && this.cfg.count && this.cfg.count.option) return this.cfg.count.option;
if (role === 'colour') {
var found = null; (this.product.options || []).forEach(function (n) { if (!found && /colou?r|finish|metal/i.test(n)) found = n; });
return found;
}
return null;
};
P.prototype.optVal = function (name) {
if (!name || !this.variant) return null;
var r = { colour: 1, count: 1, bundle: 1 };
if (r[name]) name = this.optName(name);
var i = this.optIndex[lc(name)];
return i == null ? null : this.variant.o[i];
};
P.prototype.form = function () { return document.getElementById(this.formId); };
P.prototype.readVariant = function () {
var f = this.form(), id = null;
if (f) { var inp = f.querySelector('[name="id"]'); if (inp) id = parseInt(inp.value, 10); }
if (!id) id = this.product.sel;
var v = null; (this.product.variants || []).forEach(function (x) { if (x.id === id) v = x; });
var changed = !this.variant || !v || v.id !== this.variant.id;
this.variant = v || this.product.variants[0];
return changed;
};
P.prototype.colour = function () {
if (this._forceColour !== undefined) return this._forceColour;
if (this.colourIsVariant) return this.optVal('colour');
return this.st.colour;
};
P.prototype.isBlank = function () {
var list = (this.cfg.blankValues || BLANK_DEFAULT).map(lc), blank = false, names = this.product.options || [];
((this.variant && this.variant.o) || []).forEach(function (v, i) {
if (/box|packag|gift|wrap|bag|pouch|card/i.test(names[i] || '') || /\bbox\b|pouch|\bbag\b|wrap/i.test(v || '')) return;
var s = lc(v); if (s === '-' || s === '#' || /\(sample\)|\bblank \(|^blank$/.test(s)) blank = true;
list.forEach(function (b) { if (b && s.indexOf(b) === 0) blank = true; });
});
return blank;
};
P.prototype.cond = function (c) {
if (!c) return true;
if (Array.isArray(c)) { for (var i = 0; i < c.length; i++) if (!this.cond(c[i])) return false; return true; }
var v = this.optVal(c.option);
if (c.option === 'colour' && !this.colourIsVariant) v = this.st.colour;
var s = lc(v);
if (c.contains) { var cs = [].concat(c.contains), ok = false; cs.forEach(function (x) { if (s.indexOf(lc(x)) >= 0) ok = true; }); if (!ok) return false; }
if (c.notContains) { var ok2 = true; [].concat(c.notContains).forEach(function (x) { if (s.indexOf(lc(x)) >= 0) ok2 = false; }); if (!ok2) return false; }
if (c['in']) { if ([].concat(c['in']).map(lc).indexOf(s) < 0) return false; }
if (c.min != null) { var n = firstInt(v); if (n == null || n < c.min) return false; }
if (c.max != null) { var n2 = firstInt(v); if (n2 == null || n2 > c.max) return false; }
return true;
};
P.prototype.allFaces = function () {
var me = this, out = [];
this.cfg.faces.forEach(function (f) {
if (!me.cond(f.show)) return;
if (f.repeat) {
var n = clamp(firstInt(me.optVal(f.repeat.option)) || 1, 1, f.repeat.max || 10);
for (var i = 1; i <= n; i++) { var g = clone(f); g.id = f.id + '-' + i; g.label = (f.repeat.label || f.label + ' {n}').replace('{n}', i); g._base = f.id; out.push(g); }
} else out.push(f);
});
return out;
};
})();